import React from 'react';
import PropTypes from 'prop-types';

function TitleComponent({
  headerSize = [1, ''],
  headingText = '',
  titleParentClass = 'parent-Class',
}) {
  const HeaderElement = `h${headerSize[0]}`;

  return (
    <div className={titleParentClass}>
      <HeaderElement className={headerSize[1]}>{headingText}</HeaderElement>
    </div>
  );
}

TitleComponent.propTypes = {
  headerSize: PropTypes.array,
  headingText: PropTypes.string,
  titleParentClass: PropTypes.string,
};

export { TitleComponent };
